import React from 'react';
import Icon from '../../../components/AppIcon';

const NewsStats = ({ totalArticles, filteredCount, filters, searchQuery, onCategoryClick, newsData = [] }) => {
  const getStatsText = () => {
    if (searchQuery || filters?.category !== 'all' || filters?.priority !== 'all') {
      return `แสดง ${filteredCount?.toLocaleString('th-TH')} จาก ${totalArticles?.toLocaleString('th-TH')} ข่าว`;
    }
    return `ทั้งหมด ${totalArticles?.toLocaleString('th-TH')} ข่าว`;
  };

  // คำนวณจำนวนข่าวตามหมวดหมู่จากฐานข้อมูล
  const getCategoryCount = (category) => {
    if (category === 'ข่าวสาร') {
      // ปุ่ม "ข่าวสาร" ให้รวม "ข่าวประชาสัมพันธ์" ด้วย
      return newsData.filter(article => 
        article?.category === 'ข่าวสาร' || 
        article?.category === 'ข่าวประชาสัมพันธ์' ||
        article?.category === 'Public Relations News' ||
        article?.category === 'News'
      ).length;
    }
    if (category === 'ประกาศ') {
      // ปุ่ม "ประกาศ" แสดงเฉพาะข่าวที่มีหมวดหมู่ "ประกาศ" ในตาราง news
      return newsData.filter(article => article?.category === 'ประกาศ').length;
    }
    return newsData.filter(article => article?.category === category).length;
  };

  const categoryStats = [
    { category: 'ประกาศ', count: getCategoryCount('ประกาศ'), color: 'bg-primary', icon: 'Megaphone' },
    { category: 'ข่าวสาร', count: getCategoryCount('ข่าวสาร'), color: 'bg-secondary', icon: 'Newspaper' },
    { category: 'กิจกรรม', count: getCategoryCount('กิจกรรม'), color: 'bg-accent', icon: 'Calendar' },
    { category: 'บริการ', count: getCategoryCount('บริการ'), color: 'bg-success', icon: 'Settings' },
    { category: 'เตือนภัย', count: getCategoryCount('เตือนภัย'), color: 'bg-warning', icon: 'AlertTriangle' },
    { category: 'ด่วน', count: getCategoryCount('ด่วน'), color: 'bg-error', icon: 'Zap' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6 shadow-government">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
        {/* Main Stats */}
        <div className="mb-4 lg:mb-0">
          <h2 className="text-xl font-semibold text-foreground mb-2">
            ข่าวสารและประชาสัมพันธ์
          </h2>
          <p className="text-muted-foreground flex items-center space-x-2">
            <Icon name="FileText" size={16} />
            <span>{getStatsText()}</span>
          </p>
        </div>

        {/* Category Quick Stats */}
        <div className="grid grid-cols-3 lg:grid-cols-6 gap-3">
          {categoryStats?.map((stat) => (
            <div
              key={stat?.category}
              className="text-center p-2 rounded-md hover:bg-muted transition-government cursor-pointer"
              title={`${stat?.category}: ${stat?.count} ข่าว`}
              onClick={() => onCategoryClick && onCategoryClick(stat?.category)}
            >
              <div className={`w-8 h-8 ${stat?.color} rounded-full flex items-center justify-center mx-auto mb-1`}>
                <Icon name={stat?.icon} size={14} className="text-white" />
              </div>
              <div className="text-xs font-medium text-foreground">
                {stat?.count}
              </div>
              <div className="text-xs text-muted-foreground truncate">
                {stat?.category}
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Last Updated */}
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <div className="flex items-center space-x-1">
            <Icon name="Clock" size={14} />
            <span>อัปเดตล่าสุด: {new Date()?.toLocaleDateString('th-TH', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Rss" size={14} />
            <span>RSS Feed พร้อมใช้งาน</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsStats;